module.exports = __webpack_public_path__ + "assets/icons/baseline-filter_b_and_w-24px-26cb.svg";